export default "__VITE_ASSET__CEMh30oG__"